import { DisplayDemoRequest } from "./DisplayDemoRequest";
import { demoSiteOrigin } from "./demoSiteOrigin";

export const defaultDisplayDemoRequest: DisplayDemoRequest = {
  url: demoSiteOrigin,
  scroll: false
};
